export const templateFileDownloader = {
  methods: {
    downloadDocx() {
      this.$cmsService.letterTemplate().then(response => {
        let a = document.createElement('a')
        a.href =
          'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' +
          response
        a.download = 'TAM_Briefvorlage.docx'
        a.click()
        this.docxDownloaded = true
      })
    }
  }
}
